import * as React from "react";
import { Info, LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

interface HintProps extends React.HTMLAttributes<HTMLParagraphElement> {
  icon?: LucideIcon;
  className?: string;
  classNameText?: string;
}

const Hint = React.forwardRef<HTMLParagraphElement, HintProps>(
  ({ className, classNameText, icon: Icon = Info, ...props }, ref) => (
    <p
      ref={ref}
      className={cn(
        "text-sm text-muted-foreground flex flex-row gap-3",
        className,
      )}
      {...props}
    >
      <Icon size={16} className="flex-shrink-0" />
      <span className={classNameText}>{props.children}</span>
    </p>
  ),
);

Hint.displayName = "Hint";

export { Hint };
